var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6668 3.6665C7.04016 3.6665 1.66683 8.14384 1.66683 13.6665C1.66683 16.4118 2.9935 18.8985 5.14283 20.7052C5.30391 20.8367 5.43427 21.0019 5.52478 21.1892C5.6153 21.3764 5.66378 21.5812 5.66683 21.7892V24.9998H8.3335L9.39216 23.4892C9.47405 23.3762 9.58809 23.2906 9.7194 23.2435C9.8507 23.1964 9.99316 23.19 10.1282 23.2252C12.4498 23.8196 14.8838 23.8196 17.2055 23.2252C17.3405 23.19 17.483 23.1964 17.6143 23.2435C17.7456 23.2906 17.8596 23.3762 17.9415 23.4892L19.0002 24.9998H21.6668V21.8198C21.6668 21.604 21.7193 21.3913 21.8196 21.2002C21.9199 21.009 22.0652 20.8451 22.2428 20.7225C23.6762 19.7358 28.3335 17.8025 28.3335 15.7438V13.6665C28.3335 12.8772 27.7362 12.2385 27.0002 12.2385C26.1908 12.2385 25.5308 11.9238 25.2642 11.0878C23.8988 6.8145 19.2242 3.6665 13.6668 3.6665Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 7.66667C12.4891 7.23349 13.4038 7.00482 14.3333 7C15.2613 7 16.1573 7.23333 17 7.66667M21 11.6667H20.988M3 8.33333C2.33333 7.66667 1.66667 6.41733 1.66667 4.77333C1.66667 2.69067 3.45733 1 5.66667 1C6.13333 1 6.58267 1.076 7 1.21467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/Finance.d4364bfaa08f61adc6d0e72a7539f441.svg";
export { ForwardRef as ReactComponent };